// extracted by mini-css-extract-plugin
module.exports = {"actions":"_1LN0kG5CR9_AKEzLF7uH_X","showResults":"_1OAE9oOC16OVd3QM17067g","choices":"_7pdZ3StW2LE3owBUJcyEl"};